import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link, type LinkProps } from "@tanstack/react-router";
//
import { Container, Alert, Center } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

type PageMovedPageProps = Pick<LinkProps, "to" | "params" | "search">;

export const PageMovedPage = React.memo<PageMovedPageProps>((props) => {
  const { t } = useTranslation();

  return (
    <Container pt="xl">
      <h1>{t("pageMoved.title")}</h1>

      {props.to ? (
        <Trans
          i18nKey="pageMoved.description"
          t={t}
          values={{ routeName: props.to }}
          components={{
            Link: <Link {...props} />,
          }}
        />
      ) : null}

      <Center mt="lg">
        <Alert
          w={{ sm: "75%" }}
          color="yellow"
          title={t("pageMoved.bookmarkWarning")}
          icon={<IconInfoCircle />}
        >
          {t("pageMoved.bookmarkWarningDescr")}
        </Alert>
      </Center>
    </Container>
  );
});

PageMovedPage.displayName = "PageMovedPage";
